import React from 'react';
import PropTypes from 'prop-types';

export default class RadioButton extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return <div className={`proc-radio-button-container ${this.props.className}`}>{this._renderRadioButtons()}</div>;
  }

  _renderRadioButtons() {
    return this.props.values.map((value, index) => {
      return (
        <div key={index} className={`radio-container`}>
          <div
            className={`radio-button primary100-border-color`}
            onClick={this.props.value === value ? null : this._onClick.bind(this, value)}
          >
            {this.props.value === value && <div className={'selected primary100-bg-color'} />}
          </div>
        </div>
      );
    });
  }

  _onClick(value) {
    this.props.onSelected(value);
  }
}

RadioButton.propTypes = {
  value: PropTypes.string,
  values: PropTypes.array,
  onSelected: PropTypes.func,
  className: PropTypes.string,
};

RadioButton.defaultProps = {};
